<bk-modal [title]="title" (closed)="hideConfirmationModal()">
  <div [innerHTML]="body"></div>
  <form bk-modal-footer (ngSubmit)="onConfirm()" *ngIf="active" class="d-flex justify-content-end gap-2 mb-0">
    <button type="button" bkButton kind="outlined" color="secondary" (click)="onCancel()">{{noButton}}</button>
    <button type="submit" bkButton color="success">{{yesButton}}</button>
  </form>
</bk-modal>
